import "./Skeleton.css";

/**
 * shadcn-style Skeleton primitive.
 * Provides a pulse / shimmer animation placeholder for loading states.
 */
export function Skeleton({ className = "", style = {}, ...props }) {
  return (
    <div
      className={`shadcn-skeleton ${className}`}
      style={style}
      aria-hidden="true"
      {...props}
    />
  );
}

export default Skeleton;
